import { render, staticRenderFns } from "./DomainTagInput.vue?vue&type=template&id=c80e1be0&scoped=true"
import script from "./DomainTagInput.vue?vue&type=script&lang=js"
export * from "./DomainTagInput.vue?vue&type=script&lang=js"
import style0 from "./DomainTagInput.vue?vue&type=style&index=0&id=c80e1be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80e1be0",
  null
  
)

export default component.exports